<template>
  <transition name="fade-bottom" mode="out-in">
    <slot></slot>
  </transition>
</template>
